module.exports = __webpack_public_path__ + "img/live-layer.39de44ae.png";